import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isValidatePersonalTimeRecordsUpToDateRequestFailure({ uuid }) {
      const req = getState().find(({ resource }) => uuid === resource.uuid);

      return req ? req.request.isFailure : false;
    },
    isValidatePersonalTimeRecordsUpToDateRequestPending({ uuid }) {
      const req = getState().find(({ resource }) => uuid === resource.uuid);

      return req ? req.request.isPending : false;
    },
    isValidatePersonalTimeRecordsUpToDateRequestSuccess({ uuid }) {
      const req = getState().find(({ resource }) => uuid === resource.uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
